/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

/**
 * Change how the client authenticates at the issuer's token endpoint.
 */
export const UpdateGlobalRemoteSessionClientFormTokenEndpointAuthMethod = {
  ClientSecretBasic: "client_secret_basic",
  ClientSecretPost: "client_secret_post",
  None: "none",
} as const;
/**
 * Change how the client authenticates at the issuer's token endpoint.
 */
export type UpdateGlobalRemoteSessionClientFormTokenEndpointAuthMethod =
  ClosedEnum<typeof UpdateGlobalRemoteSessionClientFormTokenEndpointAuthMethod>;

/**
 * Form for updating a global remote_session_client without organization-owned signing keys.
 */
export type UpdateGlobalRemoteSessionClientForm = {
  /**
   * Replace the upstream OAuth audience sent for this client. Omit to leave unchanged.
   */
  audience?: string | undefined;
  /**
   * Rotate the client secret. Speakeasy re-encrypts before persisting.
   */
  clientSecret?: string | undefined;
  /**
   * The remote_session_client id.
   */
  id: string;
  /**
   * Replace the explicit upstream OAuth scopes for this client. Omit to leave unchanged.
   */
  scope?: Array<string> | undefined;
  /**
   * Change how the client authenticates at the issuer's token endpoint.
   */
  tokenEndpointAuthMethod?:
    | UpdateGlobalRemoteSessionClientFormTokenEndpointAuthMethod
    | undefined;
};

/** @internal */
export const UpdateGlobalRemoteSessionClientFormTokenEndpointAuthMethod$outboundSchema:
  z.ZodMiniEnum<
    typeof UpdateGlobalRemoteSessionClientFormTokenEndpointAuthMethod
  > = z.enum(UpdateGlobalRemoteSessionClientFormTokenEndpointAuthMethod);

/** @internal */
export type UpdateGlobalRemoteSessionClientForm$Outbound = {
  audience?: string | undefined;
  client_secret?: string | undefined;
  id: string;
  scope?: Array<string> | undefined;
  token_endpoint_auth_method?: string | undefined;
};

/** @internal */
export const UpdateGlobalRemoteSessionClientForm$outboundSchema: z.ZodMiniType<
  UpdateGlobalRemoteSessionClientForm$Outbound,
  UpdateGlobalRemoteSessionClientForm
> = z.pipe(
  z.object({
    audience: z.optional(z.string()),
    clientSecret: z.optional(z.string()),
    id: z.string(),
    scope: z.optional(z.array(z.string())),
    tokenEndpointAuthMethod: z.optional(
      UpdateGlobalRemoteSessionClientFormTokenEndpointAuthMethod$outboundSchema,
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      clientSecret: "client_secret",
      tokenEndpointAuthMethod: "token_endpoint_auth_method",
    });
  }),
);

export function updateGlobalRemoteSessionClientFormToJSON(
  updateGlobalRemoteSessionClientForm: UpdateGlobalRemoteSessionClientForm,
): string {
  return JSON.stringify(
    UpdateGlobalRemoteSessionClientForm$outboundSchema.parse(
      updateGlobalRemoteSessionClientForm,
    ),
  );
}
